import * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import type { ListBoxType } from '@/components/ListBox/ListBox';
import { ListBox } from '@/components/ListBox/ListBox';

import HighIcon from './icons/high.svg?react';
import LowIcon from './icons/low.svg?react';
import MediumIcon from './icons/medium.svg?react';

const Container = styled.span`
  ${tw`flex items-center gap-1 cursor-pointer`}

  > span:first-child {
    ${tw`w-4 h-4`}
  }

  svg,
  img {
    ${tw`w-full h-full`}
  }
`;

export const OPTIONS = [
  {
    value: 'HIGH',
    label: 'High',
    icon: <HighIcon />,
  },
  {
    value: 'MEDIUM',
    label: 'Medium',
    icon: <MediumIcon />,
  },
  {
    value: 'LOW',
    label: 'Low',
    icon: <LowIcon />,
  },
];

export type OptionType = typeof OPTIONS[number];

const optionRenderer = ({ icon, label }: OptionType): JSX.Element => {
  return (
    <Container>
      <span>{icon}</span>
      <span>{label}</span>
    </Container>
  );
};

export const PriorityList = React.forwardRef(
  (props: Partial<ListBoxType<OptionType>>, ref: React.Ref<HTMLDivElement>) => {
    return (
      <ListBox
        ref={ref}
        arrow
        options={OPTIONS}
        id={props.id}
        label='Priority'
        uniqueKey='value'
        renderOption={optionRenderer}
        getOptionLabel={optionRenderer}
        bordered
        selectedOption={({ value }, selectedValue) => {
          return value === selectedValue;
        }}
        noAnimation
        {...props}
      />
    );
  }
);
